<template lang="pug">
div(v-if="hasAssignees")
  .assignee.d-flex.align-items-center(
    v-for="assignee in task.assignees"
    :key="assignee.id"
  )
    PopoverAvatar(
      :user-id="assignee.id"
      :organization-id="organization.id"
    )
      AppAvatar(:avatar="assignee.avatar_path")
    | {{ assignee.name }}
</template>

<script>
import PopoverAvatar from '~/components/PopoverAvatar.vue';

export default {
  name: 'TasksListAssignees',
  components: { PopoverAvatar },
  props: {
    task: {
      type: Object,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAssignees() {
      return this.task.assignees && !!this.task.assignees.length;
    },
  },
};
</script>
